import React from 'react';
import PageTitleComponent from "../../../components/common/PageTitle/PageTitle.component";
import styles from './hiw.module.scss'
import {ReactComponent as Path} from './path.svg';
import {ReactComponent as First} from '../../../assets/images/hiw/hiw_d_1.svg';
import {ReactComponent as Second} from '../../../assets/images/hiw/hiw_d_2.svg';
import {ReactComponent as Third} from '../../../assets/images/hiw/hiw_d_3.svg';
import TopBar from "../TopBar/TopBar";

const SeaDot = () => (
    <div className={styles['sea-dot']}>{''}</div>
)



const HowItWorksItem = (props: {item: any}) => {
  return (
          <div className={`col align-items-start gap-20 ${styles['hiw-card']}`}>
              <div className={'row align-items-center gap-15'}>
                  <div style={{width: 70, height: 70, borderRadius: 35, background: '#343643'}} className={'row align-items-center justify-content-center'}>
                      <span className={'h2-text sea-text'}>{props.item.number}</span>

                  </div>
                  <div className={'col'}>
                      <span className={'spot-title'}>{props.item.title}</span>
                  </div>
              </div>
              <div className={`col gap-8 ${styles.content}`}>


                  {props.item.content.map((item: any)=>(
                      <div className={`row align-items-center gap-10 ${styles['hiw-block-items']}`}>
                          <SeaDot />
                          <span style={{wordWrap: 'break-word'}}>{item}</span>
                      </div>
                  ))}
              </div>
          </div>
  )
}

const HowItWorks = () => {
    const hiwItems = [
        {
            number: '01',
            title: 'Start',
            content: [
                    'Book and pay for the required office, after which you will receive a personal code',
                    'As soon as your time comes, from the first minute the code will apply to the main door of the building and your office'
            ]
        },
        {
            number: '02',
            title: 'Process',
            content: [
                'If you are uncomfortable with the temperature in the office, contact the administrator in any of the ways',
                'You are not allowed to eat or leave trash inside the office. Please use the trash can',
                'We have a wonderful kitchen that you can use free of charge comfortably',
                'If you are missing cables or something doesn\'t work, contact the admin'
            ]
        },
        {
            number: '03',
            title: 'Finish',
            content: [
                'After your time, make sure you clean up after yourself and turn off the lights',
                'You have 55 minutes for your lesson and the rest 5 minutes for packing and getting ready to leave'
            ]
        }
    ]
    return (
        <div className={`wrapper relative col ${styles.page}`}>
            <TopBar backLink={'/'} MiddlePart={'How it works'}/>

            <Path className={styles.path} />


            <div className={'row align-items-center justify-content-between'}>
                <HowItWorksItem item={hiwItems[0]} />
            </div>
            <First className={'mt-30'} style={{zIndex: 1, width: 320, height: 307,  marginInline: 'auto'}} />
            <div className={`mt-50 row ${styles.second}`}>
                <HowItWorksItem item={hiwItems[1]} />
            </div>
            <Second style={{zIndex: 1, width: 320, height: 307,  marginInline: 'auto'}} />
            <div className={`row mt-50 ${styles.third}`}>
                <HowItWorksItem item={hiwItems[2]} />
            </div>
            <Third  style={{zIndex: 1, width: 320, height: 307,  marginInline: 'auto'}} />
            <div className={'mt-50 col gap-20'} >
                <span className={'text-price'}>Plan of the building</span>
                <img height={218} width={350} src={require('./draftnew.png')}/>
            </div>
        </div>
    );
};

export default HowItWorks;
export {};
